import Appsignal from '@appsignal/javascript'
import { APP_SIGNAL_API_KEY } from 'utils/env'

export const appsignal = new Appsignal({
  key: APP_SIGNAL_API_KEY,
})
